import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg';
import classname from 'classnames';

export const Checkbox = ({ ['data-testid']: dataTestId, addClass, selected, handleUpdateItemSelect = null, disabled, indeterminate }) => {
	const checkBoxClass = classname(
		addClass, {
		"use-case-request__checkbox": true,
		"use-case-request__checkbox--active": selected,
		"use-case-request__checkbox--disabled": disabled,
		"use-case-request__checkbox--indeterminate": indeterminate,
	});

	return (
		<div
			data-testid={dataTestId}
			className={checkBoxClass}
			tabIndex={0}
			onClick={() => !disabled && handleUpdateItemSelect && handleUpdateItemSelect(!selected)}
			onKeyDown={() => !disabled && handleUpdateItemSelect && handleUpdateItemSelect(!selected)}
		>
			{selected ? <IconTick /> : null}
		</div>
	);
};

export default Checkbox;
